import styled from 'styled-components';

import NormalBody from './../../shared/Body';

const Body = styled(NormalBody)`
  margin-top: 2em;
`;

export default Body;



// WEBPACK FOOTER //
// ./client/components/Booking/Policy/Body.js